<script setup lang="ts">
import Sidebar from '@/components/Sidebar/Sidebar.vue'
import { RouterView } from 'vue-router'
import { useLayout } from '@/composables/useLayout'
import { useLoading } from '@/composables/useLoading'
import NavBar from '@/components/NavBar/NavBar.vue'

const { globalLoading } = useLoading()
const { isSidebarOpen, toggleSidebar } = useLayout()
</script>

<template>
  <v-app>
    <v-layout>
      <NavBar :show-menu="true" @toggle-drawer="toggleSidebar" />
      <div class="w-100 d-flex position-relative">
        <Sidebar v-model="isSidebarOpen" />
        <LoadingIcon v-show="globalLoading" />

        <RouterView
          v-if="!globalLoading"
          class="w-100 bg-grey-lighten-4 overflow-y-auto"
        />
      </div>
    </v-layout>
  </v-app>
</template>
